'use strict';

import { Entity } from '../Entity';

export class IndDocument extends Entity {
  protected indDocId;
  protected userId = '0';
  protected indId = '0';
  protected indDocName;
  protected indDocSystemName;
  protected indDocDate;
  protected indDocSize;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.indDocId = data.indDocId;
    this.userId = data.userId;
    this.indId = data.indId;
    this.indDocName = data.indDocName;
    this.indDocSystemName = data.indDocSystemName;
    this.indDocDate = data.indDocDate;
    this.indDocSize = data.indDocSize;
  }

  public getIndDocId() {
    return this.indDocId;
  }

  public getUserId() {
    return this.userId;
  }

  public getIndId() {
    return this.indId;
  }

  public getIndDocName() {
    return this.indDocName;
  }

  public getIndDocSystemName() {
    return this.indDocSystemName;
  }

  public getIndDocDate() {
    return this.indDocDate;
  }

  public getIndDocSize() {
    return this.indDocSize;
  }
}
